import React from 'react';
import I18n from 'i18n-js';
import { RCGuidePopover } from '@reverbdotcom/cadence/components';

interface IProps {
  anchor: JSX.Element;
  isOpen: boolean;
  onDismiss: () => void;
}

export function SellerOpenToOffersPopover({ anchor, isOpen, onDismiss }: IProps) {
  return (
    <RCGuidePopover
      title={I18n.t('commons.offers.sellerOpenToOffersPopover.title')}
      content={I18n.t('commons.offers.sellerOpenToOffersPopover.content')}
      isOpen={isOpen}
      onDismiss={onDismiss}
      anchor={anchor}
      preventAutoFocus
    />
  );
}
